/* George Perfum — motor visual v2 "Vitrina nocturna"
   Polvo dorado, recorte de fondos blancos, cursor, hero 3D, vitrina,
   colecciones, manifiesto, inclinación de tarjetas y barra fija de compra.
   Todo respeta prefers-reduced-motion. */
(() => {
  'use strict';
  const doc = document.documentElement;
  const reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fineMQ = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reduce = () => reduceMQ.matches;
  const fine = () => fineMQ.matches;
  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp = (v, min, max) => Math.min(max, Math.max(min, v));
  const idle = window.requestIdleCallback
    ? (fn, o) => window.requestIdleCallback(fn, o)
    : (fn) => setTimeout(() => fn({ timeRemaining: () => 8, didTimeout: true }), 40);

  /* 1. Polvo dorado (fondo ambiental) */
  function initAmbient() {
    if (reduce() || document.querySelector('.gp-ambient')) return;
    const c = document.createElement('canvas');
    c.className = 'gp-ambient';
    c.setAttribute('aria-hidden', 'true');
    document.body.prepend(c);
    const ctx = c.getContext('2d');
    const sprite = document.createElement('canvas');
    sprite.width = sprite.height = 32;
    const s = sprite.getContext('2d');
    const g = s.createRadialGradient(16, 16, 0, 16, 16, 16);
    g.addColorStop(0, 'rgba(255,240,190,1)');
    g.addColorStop(0.22, 'rgba(212,175,55,0.8)');
    g.addColorStop(1, 'rgba(212,175,55,0)');
    s.fillStyle = g;
    s.fillRect(0, 0, 32, 32);
    let w = 0, h = 0, raf = 0, last = 0, sy = window.scrollY;
    const parts = [];
    const spawn = (anywhere) => ({
      x: Math.random() * w,
      y: anywhere ? Math.random() * h : h + 12,
      r: 0.5 + Math.random() * 1.9,
      vy: -(0.06 + Math.random() * 0.24),
      vx: (Math.random() - 0.5) * 0.1,
      a: 0.12 + Math.random() * 0.5,
      t: Math.random() * 6.28,
      z: 0.35 + Math.random() * 0.65
    });
    function size() {
      const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      w = window.innerWidth;
      h = window.innerHeight;
      c.width = Math.round(w * dpr);
      c.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = w < 750 ? 30 : 64;
      while (parts.length < n) parts.push(spawn(true));
      parts.length = n;
    }
    function frame(ts) {
      raf = requestAnimationFrame(frame);
      if (ts - last < 33) return;
      last = ts;
      const dy = window.scrollY - sy;
      sy = window.scrollY;
      ctx.clearRect(0, 0, w, h);
      for (const p of parts) {
        p.t += 0.03;
        p.x += p.vx + Math.sin(p.t * 0.5) * 0.08;
        p.y += p.vy - dy * 0.05 * p.z;
        if (p.y < -16) Object.assign(p, spawn(false));
        if (p.y > h + 40) p.y = -10;
        if (p.x < -16) p.x = w + 10;
        if (p.x > w + 16) p.x = -10;
        const size = p.r * 6 * p.z;
        ctx.globalAlpha = p.a * (0.55 + 0.45 * Math.sin(p.t));
        ctx.drawImage(sprite, p.x - size / 2, p.y - size / 2, size, size);
      }
      ctx.globalAlpha = 1;
    }
    size();
    raf = requestAnimationFrame(frame);
    let rt = 0;
    window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(size, 200); });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { cancelAnimationFrame(raf); raf = 0; }
      else if (!raf) raf = requestAnimationFrame(frame);
    });
  }

  /* 2. Cursor dorado (solo puntero fino) */
  function initCursor() {
    if (reduce() || !fine() || document.querySelector('.gp-cursor')) return;
    const d = document.createElement('div');
    d.className = 'gp-cursor';
    d.setAttribute('aria-hidden', 'true');
    document.body.appendChild(d);
    let x = -100, y = -100, cx = -100, cy = -100, raf = 0, shown = false;
    function loop() {
      cx = lerp(cx, x, 0.22);
      cy = lerp(cy, y, 0.22);
      d.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
      raf = Math.abs(cx - x) > 0.2 || Math.abs(cy - y) > 0.2 ? requestAnimationFrame(loop) : 0;
    }
    window.addEventListener('pointermove', (e) => {
      if (e.pointerType !== 'mouse') return;
      x = e.clientX; y = e.clientY;
      if (!shown) { shown = true; cx = x; cy = y; d.classList.add('is-on'); }
      if (!raf) raf = requestAnimationFrame(loop);
    }, { passive: true });
    document.addEventListener('pointerover', (e) => {
      const t = e.target.closest && e.target.closest('a, button, [role="tab"], label, summary, select, input, textarea, .card-wrapper');
      d.classList.toggle('is-hover', !!t);
    }, { passive: true });
    document.addEventListener('mouseout', (e) => {
      if (!e.relatedTarget) { d.classList.remove('is-on'); shown = false; }
    });
    document.addEventListener('pointerdown', () => d.classList.add('is-down'));
    document.addEventListener('pointerup', () => d.classList.remove('is-down'));
  }

  /* 3. Recorte de fondos blancos (sin tocar los productos) */
  const CUT_SEL = [
    '.product-card-wrapper .card__media img',
    '.gp-arch__shape img',
    '.product__media img',
    '.product-media-container img',
    '.cart-item__image',
    '.gp-cols__frame img',
    '.gp-cols__thumb img',
    '.gp-finder__media img',
    '.gp-sticky__media img',
    '.predictive-search__image'
  ].join(',');
  const cutCache = new Map();
  const queue = [];
  let pumping = false;
  function srcKey(img) {
    const s = img.currentSrc || img.src || '';
    try {
      const u = new URL(s, location.href);
      return u.pathname + '?' + (u.searchParams.get('v') || '');
    } catch (e) { return s; }
  }
  function sameOrigin(img) {
    try { return new URL(img.currentSrc || img.src, location.href).origin === location.origin; }
    catch (e) { return false; }
  }
  function mark(img, type) {
    img.dataset.gpCut = type;
    const box = img.closest('.card__inner, .gp-arch, .product-media-container, .product__media-item, .cart-item__media, .gp-cols__frame, .gp-finder__media, .gp-sticky__media');
    if (box && !box.dataset.gpCut) box.dataset.gpCut = type;
  }
  function apply(img, r) {
    if (r.type === 'cut') {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = r.url;
    }
    mark(img, r.type);
  }
  function cutout(img) {
    const nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return { type: 'photo' };
    const sc = Math.min(1, 680 / Math.max(nw, nh));
    const w = Math.max(1, Math.round(nw * sc)), h = Math.max(1, Math.round(nh * sc));
    const cv = document.createElement('canvas');
    cv.width = w; cv.height = h;
    const cx = cv.getContext('2d', { willReadFrequently: true });
    cx.drawImage(img, 0, 0, w, h);
    const id = cx.getImageData(0, 0, w, h);
    const d = id.data;
    const strict = (p) => {
      const i = p * 4, r = d[i], g = d[i + 1], b = d[i + 2];
      return r + g + b >= 705 && Math.max(r, g, b) - Math.min(r, g, b) <= 24;
    };
    const loose = (p) => {
      const i = p * 4, r = d[i], g = d[i + 1], b = d[i + 2];
      return r + g + b >= 672 && Math.max(r, g, b) - Math.min(r, g, b) <= 30;
    };
    let tot = 0, wh = 0;
    const step = Math.max(1, Math.floor((w + h) / 240));
    for (let x = 0; x < w; x += step) {
      tot += 2;
      if (strict(x)) wh++;
      if (strict((h - 1) * w + x)) wh++;
    }
    for (let y = 0; y < h; y += step) {
      tot += 2;
      if (strict(y * w)) wh++;
      if (strict(y * w + w - 1)) wh++;
    }
    if (wh / tot < 0.7) return { type: 'photo' };
    const n = w * h;
    const seen = new Uint8Array(n);
    const q = new Int32Array(n);
    let qh = 0, qt = 0;
    const push = (p) => { if (!seen[p] && loose(p)) { seen[p] = 1; q[qt++] = p; } };
    for (let x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
    for (let y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
    while (qh < qt) {
      const p = q[qh++];
      const x = p % w, y = (p - x) / w;
      if (x > 0) push(p - 1);
      if (x < w - 1) push(p + 1);
      if (y > 0) push(p - w);
      if (y < h - 1) push(p + w);
    }
    if (qt < n * 0.08 || qt > n * 0.97) return { type: 'photo' };
    let minX = w, minY = h, maxX = 0, maxY = 0;
    for (let p = 0; p < n; p++) {
      const i = p * 4;
      if (seen[p]) { d[i + 3] = 0; continue; }
      const x = p % w, y = (p - x) / w;
      const edge = (x > 0 && seen[p - 1]) || (x < w - 1 && seen[p + 1]) || (y > 0 && seen[p - w]) || (y < h - 1 && seen[p + w]);
      if (edge) {
        const lum = (d[i] + d[i + 1] + d[i + 2]) / 3;
        d[i + 3] = Math.round(d[i + 3] * Math.max(clamp((255 - lum) / 48, 0, 1), 0.2));
      }
      if (d[i + 3] > 24) {
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
      }
    }
    if (maxX <= minX || maxY <= minY) return { type: 'photo' };
    cx.putImageData(id, 0, 0);
    minX = Math.max(0, minX - 2); minY = Math.max(0, minY - 2);
    maxX = Math.min(w - 1, maxX + 2); maxY = Math.min(h - 1, maxY + 2);
    const tw = maxX - minX + 1, th = maxY - minY + 1;
    const out = document.createElement('canvas');
    out.width = tw; out.height = th;
    out.getContext('2d').drawImage(cv, minX, minY, tw, th, 0, 0, tw, th);
    return { type: 'cut', canvas: out };
  }
  function processImg(img) {
    if (img.dataset.gpCut || !img.isConnected) return;
    const key = srcKey(img);
    const hit = cutCache.get(key);
    if (hit) {
      if (hit.pending) { hit.pending.push(img); return; }
      apply(img, hit);
      return;
    }
    if (!sameOrigin(img)) { mark(img, 'photo'); return; }
    let res;
    try { res = cutout(img); } catch (e) { res = { type: 'photo' }; }
    if (res.type === 'photo') { cutCache.set(key, res); mark(img, 'photo'); return; }
    const entry = { pending: [img] };
    cutCache.set(key, entry);
    res.canvas.toBlob((blob) => {
      const done = blob ? { type: 'cut', url: URL.createObjectURL(blob) } : { type: 'photo' };
      const waiting = entry.pending;
      cutCache.set(key, done);
      waiting.forEach((im) => apply(im, done));
    }, 'image/png');
  }
  function pump() {
    if (pumping) return;
    pumping = true;
    idle(function step(dl) {
      while (queue.length && (dl.didTimeout || dl.timeRemaining() > 3)) processImg(queue.shift());
      if (queue.length) idle(step, { timeout: 250 });
      else pumping = false;
    }, { timeout: 250 });
  }
  function enqueue(img) {
    if (img.dataset.gpCut || img.dataset.gpQ) return;
    img.dataset.gpQ = '1';
    const go = () => { queue.push(img); pump(); };
    if (img.complete && img.naturalWidth) go();
    else {
      img.addEventListener('load', go, { once: true });
      img.addEventListener('error', () => mark(img, 'photo'), { once: true });
    }
  }
  function scanCut(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches(CUT_SEL)) enqueue(root);
    root.querySelectorAll(CUT_SEL).forEach(enqueue);
  }
  function initCutWatcher() {
    scanCut(document);
    const mo = new MutationObserver((list) => {
      for (const m of list) m.addedNodes.forEach((n) => { if (n.nodeType === 1) scanCut(n); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* 4. Revelado al entrar en pantalla y cabecera */
  const revealIO = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealIO.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;
  function initReveal(root) {
    root.querySelectorAll('[data-gp-reveal]:not(.is-in)').forEach((el) => {
      if (revealIO) revealIO.observe(el);
      else el.classList.add('is-in');
    });
  }
  let lastY = -1;
  function onScrollHeader() {
    const y = window.scrollY;
    if ((y > 24) !== (lastY > 24)) doc.classList.toggle('gp-scrolled', y > 24);
    lastY = y;
  }

  /* 5. Hero: vitrina con profundidad */
  function initHero(root) {
    root.querySelectorAll('[data-gp-hero]').forEach((hero) => {
      if (hero.dataset.gpReady) return;
      hero.dataset.gpReady = '1';
      const stage = hero.querySelector('[data-gp-stage]');
      const arches = Array.from(hero.querySelectorAll('[data-gp-arch]'));
      const caption = hero.querySelector('[data-gp-caption]');
      if (!stage || !arches.length) return;
      function setMain(target) {
        const current = arches.find((a) => a.dataset.pos === 'main');
        if (!current || current === target) return;
        current.dataset.pos = target.dataset.pos;
        target.dataset.pos = 'main';
        arches.forEach((a) => {
          const isMain = a.dataset.pos === 'main';
          const link = a.querySelector('[data-gp-arch-link]');
          const btn = a.querySelector('[data-gp-arch-btn]');
          if (link) link.tabIndex = isMain ? 0 : -1;
          if (btn) {
            btn.tabIndex = isMain ? -1 : 0;
            btn.setAttribute('aria-hidden', isMain ? 'true' : 'false');
          }
        });
        if (caption) {
          caption.classList.add('is-swapping');
          window.setTimeout(() => {
            const name = caption.querySelector('[data-gp-cap-name]');
            const price = caption.querySelector('[data-gp-cap-price]');
            const link = caption.querySelector('[data-gp-cap-link]');
            if (name) name.textContent = target.dataset.name || '';
            if (price) price.textContent = target.dataset.price || '';
            if (link) {
              link.href = target.dataset.url || '#';
              link.setAttribute('aria-label', 'Descubrir ' + (target.dataset.name || ''));
            }
            caption.classList.remove('is-swapping');
          }, reduce() ? 0 : 240);
        }
      }
      arches.forEach((arch) => {
        const btn = arch.querySelector('[data-gp-arch-btn]');
        if (btn) btn.addEventListener('click', () => setMain(arch));
      });
      if (reduce()) return;
      let tx = 0, ty = 0, cx = 0, cy = 0, raf = 0, active = false;
      const floats = arches.map((a) => a.querySelector('[data-gp-float]'));
      function frame() {
        cx = lerp(cx, tx, 0.07);
        cy = lerp(cy, ty, 0.07);
        stage.style.transform =
          'rotateY(' + (cx * 7).toFixed(3) + 'deg) rotateX(' + (-cy * 5).toFixed(3) + 'deg)';
        floats.forEach((el, i) => {
          if (!el) return;
          const d = arches[i].dataset.pos === 'main' ? 1 : 0.45;
          el.style.transform =
            'translate3d(' + (cx * 26 * d).toFixed(2) + 'px,' + (cy * 18 * d).toFixed(2) + 'px,0)';
        });
        raf = (Math.abs(cx - tx) > 0.001 || Math.abs(cy - ty) > 0.001 || active) ? requestAnimationFrame(frame) : 0;
      }
      const kick = () => { if (!raf) raf = requestAnimationFrame(frame); };
      if (fine()) {
        hero.addEventListener('pointermove', (e) => {
          const r = hero.getBoundingClientRect();
          tx = clamp(((e.clientX - r.left) / r.width) * 2 - 1, -1, 1);
          ty = clamp(((e.clientY - r.top) / r.height) * 2 - 1, -1, 1);
          active = true;
          kick();
        });
        hero.addEventListener('pointerleave', () => { tx = 0; ty = 0; active = false; kick(); });
      }
    });
  }

  /* 6. Colecciones: vista previa al pasar */
  function initCollections(root) {
    root.querySelectorAll('[data-gp-collections]').forEach((wrap) => {
      if (wrap.dataset.gpReady) return;
      wrap.dataset.gpReady = '1';
      const items = Array.from(wrap.querySelectorAll('[data-gp-col-item]'));
      const frames = Array.from(wrap.querySelectorAll('[data-gp-col-frame]'));
      const show = (i) => {
        items.forEach((it, n) => it.classList.toggle('is-active', n === i));
        frames.forEach((fr, n) => fr.classList.toggle('is-active', n === i));
      };
      items.forEach((it, i) => {
        it.addEventListener('pointerenter', () => { if (fine()) show(i); });
        it.addEventListener('focusin', () => show(i));
      });
    });
  }

  /* 7. Vitrina: pestañas y carril */
  function initVitrina(root) {
    root.querySelectorAll('[data-gp-vitrina]').forEach((wrap) => {
      if (wrap.dataset.gpReady) return;
      wrap.dataset.gpReady = '1';
      const tabs = Array.from(wrap.querySelectorAll('[role="tab"]'));
      const panels = Array.from(wrap.querySelectorAll('[role="tabpanel"]'));
      const indicator = wrap.querySelector('[data-gp-indicator]');
      function moveIndicator(tab) {
        if (!indicator || !tab) return;
        const list = tab.parentElement.getBoundingClientRect();
        const r = tab.getBoundingClientRect();
        indicator.style.transform =
          'translateX(' + (r.left - list.left + tab.parentElement.scrollLeft) + 'px) scaleX(' + r.width + ')';
      }
      function updateRail(panel) {
        if (!panel) return;
        const rail = panel.querySelector('[data-gp-rail]');
        const prev = panel.querySelector('[data-gp-prev]');
        const next = panel.querySelector('[data-gp-next]');
        if (!rail) return;
        const max = rail.scrollWidth - rail.clientWidth - 2;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
      }
      function select(i, focus) {
        tabs.forEach((t, n) => {
          t.setAttribute('aria-selected', n === i ? 'true' : 'false');
          t.tabIndex = n === i ? 0 : -1;
        });
        panels.forEach((p, n) => {
          if (n === i) {
            p.hidden = false;
            p.classList.remove('is-shown');
            void p.offsetWidth;
            p.classList.add('is-shown');
          } else p.hidden = true;
        });
        moveIndicator(tabs[i]);
        if (focus) tabs[i].focus();
        updateRail(panels[i]);
      }
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(i, false));
        t.addEventListener('keydown', (e) => {
          let n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = tabs.length - 1;
          if (n !== null) { e.preventDefault(); select(n, true); }
        });
      });
      panels.forEach((panel) => {
        const rail = panel.querySelector('[data-gp-rail]');
        if (!rail) return;
        const step = () => {
          const item = rail.querySelector('li');
          const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
          return item ? item.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
        };
        const prev = panel.querySelector('[data-gp-prev]');
        const next = panel.querySelector('[data-gp-next]');
        const behavior = reduce() ? 'auto' : 'smooth';
        if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior }));
        if (next) next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior }));
        rail.addEventListener('scroll', () => updateRail(panel), { passive: true });
      });
      const start = Math.max(0, tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true'));
      requestAnimationFrame(() => {
        moveIndicator(tabs[start]);
        updateRail(panels[start]);
        wrap.classList.add('is-ready');
      });
      window.addEventListener('resize', () => {
        moveIndicator(tabs[tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true')]);
      });
    });
  }

  /* Carriles sueltos (reseñas) */
  function initRails(root) {
    root.querySelectorAll('[data-gp-rail-wrap]').forEach((wrap) => {
      if (wrap.dataset.gpReady) return;
      wrap.dataset.gpReady = '1';
      const rail = wrap.querySelector('[data-gp-rail]');
      const prev = wrap.querySelector('[data-gp-prev]');
      const next = wrap.querySelector('[data-gp-next]');
      if (!rail) return;
      const update = () => {
        const max = rail.scrollWidth - rail.clientWidth - 2;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max;
      };
      const step = () => {
        const item = rail.querySelector('li');
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return item ? item.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      };
      const behavior = reduce() ? 'auto' : 'smooth';
      if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior }));
      if (next) next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior }));
      rail.addEventListener('scroll', update, { passive: true });
      requestAnimationFrame(update);
    });
  }

  /* 8. Manifiesto: palabras que se iluminan */
  const scrubs = [];
  function initScrub(root) {
    root.querySelectorAll('[data-gp-scrub]').forEach((el) => {
      if (el.dataset.gpReady) return;
      el.dataset.gpReady = '1';
      if (reduce()) return;
      const text = el.textContent.trim();
      const words = text.split(/\s+/);
      el.setAttribute('aria-label', text);
      el.textContent = '';
      const spans = words.map((wd, i) => {
        const s = document.createElement('span');
        s.className = 'gp-word';
        s.setAttribute('aria-hidden', 'true');
        s.textContent = wd + (i < words.length - 1 ? ' ' : '');
        el.appendChild(s);
        return s;
      });
      el.classList.add('is-scrub');
      scrubs.push({ el, spans });
    });
    updateScrub();
  }
  function updateScrub() {
    if (!scrubs.length) return;
    const vh = window.innerHeight;
    scrubs.forEach(({ el, spans }) => {
      const r = el.getBoundingClientRect();
      const p = clamp((vh * 0.85 - r.top) / (r.height + vh * 0.35), 0, 1);
      const lit = Math.round(p * spans.length);
      spans.forEach((s, i) => s.classList.toggle('is-lit', i < lit));
    });
  }

  /* 9. Tarjetas: inclinación 3D */
  let tiltEl = null, tiltRaf = 0, trx = 0, try_ = 0, crx = 0, cry = 0;
  function tiltFrame() {
    crx = lerp(crx, trx, 0.14);
    cry = lerp(cry, try_, 0.14);
    if (tiltEl) tiltEl.style.transform = 'perspective(900px) rotateX(' + crx.toFixed(2) + 'deg) rotateY(' + cry.toFixed(2) + 'deg)';
    if (Math.abs(crx - trx) > 0.02 || Math.abs(cry - try_) > 0.02) tiltRaf = requestAnimationFrame(tiltFrame);
    else {
      tiltRaf = 0;
      if (tiltEl && trx === 0 && try_ === 0) { tiltEl.style.transform = ''; tiltEl = null; }
    }
  }
  function onCardMove(e) {
    if (reduce() || !fine()) return;
    const inner = e.target.closest && e.target.closest('.product-card-wrapper .card__inner');
    if (inner !== tiltEl) {
      if (tiltEl) tiltEl.style.transform = '';
      tiltEl = inner; crx = 0; cry = 0;
    }
    if (!inner) { trx = 0; try_ = 0; return; }
    const r = inner.getBoundingClientRect();
    trx = -((e.clientY - r.top) / r.height - 0.5) * 8;
    try_ = ((e.clientX - r.left) / r.width - 0.5) * 10;
    if (!tiltRaf) tiltRaf = requestAnimationFrame(tiltFrame);
  }
  function onCardLeave(e) {
    if (!tiltEl) return;
    const to = e.relatedTarget;
    if (to && tiltEl.contains(to)) return;
    trx = 0; try_ = 0;
    if (!tiltRaf) tiltRaf = requestAnimationFrame(tiltFrame);
  }

  /* 10. Barra fija de compra (ficha de producto) */
  function initSticky(root) {
    root.querySelectorAll('[data-gp-sticky]').forEach((bar) => {
      if (bar.dataset.gpReady) return;
      bar.dataset.gpReady = '1';
      const btn = document.querySelector('.product-form__submit');
      const go = bar.querySelector('[data-gp-sticky-add]');
      if (!btn || !go) { bar.remove(); return; }
      const label = go.querySelector('span');
      const sync = () => {
        go.disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
        const src = btn.querySelector('span');
        if (src && label) label.textContent = src.textContent.trim();
        const price = document.querySelector('.product .price-item--last');
        const dst = bar.querySelector('[data-gp-sticky-price]');
        if (price && dst) dst.textContent = price.textContent.trim();
      };
      sync();
      new MutationObserver(sync).observe(btn, { attributes: true, subtree: true, childList: true, characterData: true });
      go.addEventListener('click', () => btn.click());
      const io = new IntersectionObserver(([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.inert = !show;
      });
      io.observe(btn);
    });
  }

  /* Arranque */
  function init(root) {
    initReveal(root);
    initHero(root);
    initCollections(root);
    initVitrina(root);
    initRails(root);
    initScrub(root);
    initSticky(root);
  }
  function boot() {
    initAmbient();
    initCursor();
    initCutWatcher();
    init(document);
    onScrollHeader();
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        onScrollHeader();
        updateScrub();
        ticking = false;
      });
    }, { passive: true });
    document.addEventListener('pointerover', onCardMove, { passive: true });
    document.addEventListener('pointermove', onCardMove, { passive: true });
    document.addEventListener('pointerout', onCardLeave, { passive: true });
    document.addEventListener('shopify:section:load', (e) => { init(e.target); scanCut(e.target); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
